var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useRef } from "react";
import { Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { GenericDropdown } from "../../../../../shared-library/components/GenericDropdown";
import di from "../di/serviceLocator";
import { useNavigate } from "react-router-dom";
import loaderGIF from "@frameworks/shared-library/assets/images/Reports/loaderGIF.gif";
import ClientProfileUpdatePopup from "@frameworks/salesjourney/components/Lead/ClientProfileUpdatePopup";
import leadDI from "@frameworks/salesjourney/components/Features/LeadDashboard/di/serviceLocator";
var ClientDetails = function () {
    var navigate = useNavigate();
    var _a = __read(React.useState(false), 2), dropdownLoader = _a[0], setDropdownLoader = _a[1];
    var _b = __read(React.useState([
        {
            title: "",
            value: "",
            flag: "",
        },
    ]), 2), accCodeArray = _b[0], setAccCodeArray = _b[1];
    var _c = __read(React.useState({
        title: "",
        value: "",
        flag: "",
    }), 2), selectedDropDown = _c[0], setSelectedDropdown = _c[1];
    var _d = __read(React.useState(false), 2), changeAccountCode = _d[0], setChangeAccountCode = _d[1];
    var _e = __read(React.useState(""), 2), clientTier = _e[0], setClientTier = _e[1];
    var _f = __read(React.useState(false), 2), showProfileUpdatePopUp = _f[0], setShowProfileUpdatePopUp = _f[1];
    //step-4
    var ClientHeaderAccCodeData = useSelector(function (state) { return state.Clients.ClientHeaderAccCode.reducersData.data; });
    var searchRef = useRef(null);
    //step-3
    var getClientAccounts = function (accCode) {
        di.clients.getClientHeaderAccCodeData({ accCode: accCode });
    };
    var getPartnerAccounts = function (accCode) {
        if (selectedPartner &&
            (selectedPartner === null || selectedPartner === void 0 ? void 0 : selectedPartner.fromProfileRedirection) !== null &&
            (selectedPartner === null || selectedPartner === void 0 ? void 0 : selectedPartner.fromProfileRedirection) !== undefined &&
            (selectedPartner === null || selectedPartner === void 0 ? void 0 : selectedPartner.fromProfileRedirection)) {
            di.partnerOverview.getPartnerAccountCodes({
                upcId: selectedPartner === null || selectedPartner === void 0 ? void 0 : selectedPartner.upcId,
                page: 1,
                pageSize: 100,
            });
        }
        else
            di.partnerOverview.getPartnerAccountCodes({
                AcCode: accCode,
                page: 1,
                pageSize: 100,
            });
    };
    //step-1
    var selectedAcount = useSelector(function (state) { return state.Clients.ClientSearch.reducersData.selected; });
    var selectedAccountStatus = useSelector(function (state) {
        return state.Clients.ClientOverview.reducersData.data.isAccountClosed;
    });
    var selectedPartner = useSelector(function (state) {
        return state.Partners.partnerSummary.reducersData.selectedPartner;
    });
    var partnerAccounts = useSelector(function (state) {
        return state.Partners.partnerSummary.reducersData.partnerAccounts;
    });
    var clearSelectedDropdown = useSelector(function (state) {
        return state.Partners.partnerSummary.reducersData.clearSelectedDropdown;
    });
    var _g = useSelector(function (state) { return state.Clients.ClientHeaderAccCode.commonData; }), clientAccountsLoader = _g.loader, clientAccountsError = _g.errorData;
    var _h = useSelector(function (state) { return state.Partners.partnerSummary.commonData; }), partnerAccountsLoader = _h.loader, partnerAccountsError = _h.errorData;
    var _j = useSelector(function (state) { return state.Clients.ClientSearch; }), ClientSearchData = _j.reducersData, clientSearchCommonData = _j.commonData;
    //step-2
    var getProfileDetails = function () {
        var clientProfileRequestPayload = {
            clientId: selectedAcount === null || selectedAcount === void 0 ? void 0 : selectedAcount.accountCode,
            page: "1",
            pageSize: "10",
        };
        leadDI.leads.updateClientProfileDetails(clientProfileRequestPayload);
    };
    React.useEffect(function () {
        if (selectedAcount && (selectedAcount === null || selectedAcount === void 0 ? void 0 : selectedAcount.accountCode)) {
            setAccCodeArray([]);
            getClientAccounts(selectedAcount === null || selectedAcount === void 0 ? void 0 : selectedAcount.accountCode);
            getProfileDetails();
        }
    }, [selectedAcount]);
    React.useEffect(function () {
        if (selectedPartner && (selectedPartner === null || selectedPartner === void 0 ? void 0 : selectedPartner.accountCode)) {
            if (selectedPartner === null || selectedPartner === void 0 ? void 0 : selectedPartner.isPartner) {
                if (partnerAccounts === undefined ||
                    partnerAccounts === null ||
                    (partnerAccounts === null || partnerAccounts === void 0 ? void 0 : partnerAccounts.length) === 0) {
                    if ((selectedPartner === null || selectedPartner === void 0 ? void 0 : selectedPartner.fromProfileRedirection) !== null &&
                        (selectedPartner === null || selectedPartner === void 0 ? void 0 : selectedPartner.fromProfileRedirection) !== undefined &&
                        (selectedPartner === null || selectedPartner === void 0 ? void 0 : selectedPartner.fromProfileRedirection)) {
                        di.partnerOverview.setPartnerLoaderStop();
                    }
                    else {
                        getPartnerAccounts((selectedPartner === null || selectedPartner === void 0 ? void 0 : selectedPartner.parentAccountCode)
                            ? selectedPartner === null || selectedPartner === void 0 ? void 0 : selectedPartner.parentAccountCode
                            : selectedPartner === null || selectedPartner === void 0 ? void 0 : selectedPartner.accountCode);
                    }
                    setSelectedDropdown({
                        title: selectedPartner === null || selectedPartner === void 0 ? void 0 : selectedPartner.accountCode,
                        value: selectedPartner === null || selectedPartner === void 0 ? void 0 : selectedPartner.accountCode,
                    });
                }
                else if (!!partnerAccounts && (partnerAccounts === null || partnerAccounts === void 0 ? void 0 : partnerAccounts.length) > 0) {
                    setAccCodeArray(function () {
                        var _a, _b, _c;
                        var accCodeArray = [];
                        var accountCodes = partnerAccounts === null || partnerAccounts === void 0 ? void 0 : partnerAccounts.map(function (partner) { return ({
                            title: partner === null || partner === void 0 ? void 0 : partner.partnerCode,
                            value: partner === null || partner === void 0 ? void 0 : partner.partnerCode,
                            flag: partner === null || partner === void 0 ? void 0 : partner.flag,
                        }); });
                        if ((accountCodes === null || accountCodes === void 0 ? void 0 : accountCodes.length) > 0) {
                            accCodeArray = accountCodes;
                            if (!changeAccountCode &&
                                (accountCodes === null || accountCodes === void 0 ? void 0 : accountCodes.length) > 0 &&
                                (clearSelectedDropdown ||
                                    (!!selectedDropDown &&
                                        (selectedDropDown === null || selectedDropDown === void 0 ? void 0 : selectedDropDown.title) === "" &&
                                        (selectedDropDown === null || selectedDropDown === void 0 ? void 0 : selectedDropDown.value) === ""))) {
                                setSelectedDropdown({
                                    title: (_a = accountCodes[0]) === null || _a === void 0 ? void 0 : _a.value,
                                    value: (_b = accountCodes[0]) === null || _b === void 0 ? void 0 : _b.value,
                                    flag: (_c = accountCodes[0]) === null || _c === void 0 ? void 0 : _c.flag,
                                });
                            }
                        }
                        return accCodeArray;
                    });
                }
                // else {
                //   getPartnerAccounts(selectedPartner?.accountCode);
                // }
            }
        }
        else if (!!selectedPartner &&
            (selectedPartner === null || selectedPartner === void 0 ? void 0 : selectedPartner.isPartner) &&
            !!partnerAccounts &&
            (partnerAccounts === null || partnerAccounts === void 0 ? void 0 : partnerAccounts.length) > 0) {
            setAccCodeArray(function () {
                var _a, _b, _c;
                var accCodeArray = [];
                var accountCodes = partnerAccounts === null || partnerAccounts === void 0 ? void 0 : partnerAccounts.map(function (partner) { return ({
                    title: partner === null || partner === void 0 ? void 0 : partner.partnerCode,
                    value: partner === null || partner === void 0 ? void 0 : partner.partnerCode,
                    flag: partner === null || partner === void 0 ? void 0 : partner.flag,
                }); });
                if ((accountCodes === null || accountCodes === void 0 ? void 0 : accountCodes.length) > 0) {
                    accCodeArray = accountCodes;
                    if (!changeAccountCode &&
                        (accountCodes === null || accountCodes === void 0 ? void 0 : accountCodes.length) > 0 &&
                        (clearSelectedDropdown ||
                            (!!selectedDropDown &&
                                (selectedDropDown === null || selectedDropDown === void 0 ? void 0 : selectedDropDown.title) === "" &&
                                (selectedDropDown === null || selectedDropDown === void 0 ? void 0 : selectedDropDown.value) === ""))) {
                        setSelectedDropdown({
                            title: (_a = accountCodes[0]) === null || _a === void 0 ? void 0 : _a.value,
                            value: (_b = accountCodes[0]) === null || _b === void 0 ? void 0 : _b.value,
                            flag: (_c = accountCodes[0]) === null || _c === void 0 ? void 0 : _c.flag,
                        });
                    }
                }
                return accCodeArray;
            });
        }
    }, [selectedPartner, partnerAccounts]);
    React.useEffect(function () {
        var _a;
        var accCodeArray = [];
        (_a = ClientHeaderAccCodeData === null || ClientHeaderAccCodeData === void 0 ? void 0 : ClientHeaderAccCodeData.codes) === null || _a === void 0 ? void 0 : _a.map(function (codes) {
            accCodeArray.push({
                title: codes.acCode,
                value: codes.acCode,
            });
        });
        if ((accCodeArray === null || accCodeArray === void 0 ? void 0 : accCodeArray.length) > 0) {
            setAccCodeArray(accCodeArray);
        }
        if (selectedAcount && (selectedAcount === null || selectedAcount === void 0 ? void 0 : selectedAcount.accountCode)) {
            setAccCodeArray(accCodeArray);
        }
        setDropdownLoader(false);
        setClientTier(ClientHeaderAccCodeData === null || ClientHeaderAccCodeData === void 0 ? void 0 : ClientHeaderAccCodeData.clientTire);
        if (!changeAccountCode && selectedPartner === null)
            setSelectedDropdown({
                title: ClientHeaderAccCodeData === null || ClientHeaderAccCodeData === void 0 ? void 0 : ClientHeaderAccCodeData.acCode,
                value: ClientHeaderAccCodeData === null || ClientHeaderAccCodeData === void 0 ? void 0 : ClientHeaderAccCodeData.acCode,
            });
    }, [ClientHeaderAccCodeData, selectedPartner, selectedAcount]);
    var loginData = useSelector(function (state) { return state.Login.LoginReducer.reducersData.loginData; });
    var changeAccountCodeInDropdown = function (item) {
        setSelectedDropdown(item);
        setChangeAccountCode(true);
        if (item.flag !== "" && item.flag !== null && item.flag !== undefined) {
            var updateClientSearchData = selectedPartner;
            updateClientSearchData.accountCode = item.value;
            updateClientSearchData.flag = item.flag;
            di.partnerOverview.setSelectedPartner(updateClientSearchData);
            callPartnerApis(item.value, item.flag);
        }
        else {
            di.clients.getClientSearchData({ searchText: item.value });
        }
    };
    var callPartnerApis = function (accountCode, flag) {
        di.partnerOverview.getPartnerProfDemMetNomSegDetails({
            AcCode: accountCode,
            flg: flag,
            page: 1,
            pageSize: 100,
        });
        di.partnerOverview.getPartnerClientsSummary({ accountCode: accountCode });
        di.partnerOverview.getPartnerRevenueSummary({ accountCode: accountCode });
    };
    useEffect(function () {
        var _a;
        if (changeAccountCode &&
            !clientSearchCommonData.loader &&
            !clientSearchCommonData.errorData.isOpen) {
            setChangeAccountCode(false);
            if (ClientSearchData.data.length === 1) {
                if ((_a = ClientSearchData === null || ClientSearchData === void 0 ? void 0 : ClientSearchData.data[0]) === null || _a === void 0 ? void 0 : _a.isPartner) {
                }
                else
                    di.clients.setSelectedClientOnSearchClick(ClientSearchData.data[0]);
            }
        }
    }, [clientSearchCommonData, changeAccountCode, ClientSearchData.data]);
    useEffect(function () {
        leadDI.leads.clearClientProfileData();
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: " client-details d-flex align-items-center justify-content-between" },
            React.createElement("div", { className: " d-flex align-items-center" },
                React.createElement("label", { className: "DMSan_28_700 txt-midnight-blue pe-3" }, (selectedPartner === null || selectedPartner === void 0 ? void 0 : selectedPartner.clientName) !== null &&
                    (selectedPartner === null || selectedPartner === void 0 ? void 0 : selectedPartner.clientName) !== undefined
                    ? selectedPartner === null || selectedPartner === void 0 ? void 0 : selectedPartner.clientName
                    : selectedAcount === null || selectedAcount === void 0 ? void 0 : selectedAcount.clientName)),
            React.createElement("div", { className: " right-section d-flex align-items-center justify-content-between" },
                React.createElement(React.Fragment, null,
                    clientAccountsLoader || partnerAccountsLoader ? (React.createElement("div", { className: "loader-box px-4" },
                        React.createElement("img", { src: loaderGIF }))) : (React.createElement(GenericDropdown, { externalClassname: "client-dropdown account-dropdown", itemlist: accCodeArray, defaultVal: true, selectedValue: changeAccountCodeInDropdown, selectedDefaultVal: selectedDropDown, callUseEffect: true })),
                    React.createElement("div", { className: "tier-id-section d-flex justify-content-between align-items-center" },
                        (selectedPartner === null || selectedPartner === void 0 ? void 0 : selectedPartner.userName) && (React.createElement("label", { className: "DMSanN_16_400 txt_primaryGrey" },
                            "UserId : ", selectedPartner === null || selectedPartner === void 0 ? void 0 :
                            selectedPartner.userName)),
                        selectedAcount !== null && (selectedAcount === null || selectedAcount === void 0 ? void 0 : selectedAcount.userName) && (React.createElement("label", { className: "DMSanN_16_400 txt_primaryGrey" },
                            "UserId : ", selectedAcount === null || selectedAcount === void 0 ? void 0 :
                            selectedAcount.userName)))))),
        React.createElement(Row, null,
            React.createElement("div", null, selectedAccountStatus === "Y" && (React.createElement("label", { className: "txt_bloodRed DMSans_16_500" }, "Closed Account")))),
        React.createElement(ClientProfileUpdatePopup, { showPopUp: showProfileUpdatePopUp, setShowPopUp: setShowProfileUpdatePopUp, clientId: selectedAcount === null || selectedAcount === void 0 ? void 0 : selectedAcount.accountCode })));
};
export default ClientDetails;
